import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '../services/CredentialsService.js'

const JudgeRepository = RepositoryFactory.get('judge')

class JudgeService {
  static async getJudges (params) {
    try {
      return await JudgeRepository.getJudges(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default JudgeService
